import { render, staticRenderFns } from "./DisplayJoin.vue?vue&type=template&id=72ed4f52&scoped=true&"
import script from "./DisplayJoin.vue?vue&type=script&lang=js&"
export * from "./DisplayJoin.vue?vue&type=script&lang=js&"
import style0 from "./DisplayJoin.vue?vue&type=style&index=0&id=72ed4f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed4f52",
  null
  
)

export default component.exports